module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/248.242d37ae.png";